"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var close_1 = __importDefault(require("./assets/close"));
var notification_1 = __importDefault(require("./assets/notification"));
require("./Ribbon.scss");
var DSRibbon = function (_a) {
    var state = _a.state, onClick = _a.onClick, onClose = _a.onClose;
    var message = state.message, customStyles = state.customStyles;
    var currentTheme = (customStyles === null || customStyles === void 0 ? void 0 : customStyles.theme) || 'default';
    return (jsx_runtime_1.jsx("div", __assign({ className: "ds-ribbon " + currentTheme, onClick: onClick }, { children: jsx_runtime_1.jsxs("div", __assign({ className: "ds-ribbon-container" }, { children: [jsx_runtime_1.jsx("div", { className: "ds-ribbon-number" }, void 0),
                jsx_runtime_1.jsxs("div", __assign({ className: "ds-ribbon-content" }, { children: [jsx_runtime_1.jsx(notification_1.default, { stroke: (customStyles === null || customStyles === void 0 ? void 0 : customStyles.iconColours) || 'white' }, void 0), " ", message] }), void 0),
                jsx_runtime_1.jsx("div", __assign({ className: "ds-ribbon-close pointer", onClick: onClose, role: "button", title: "Close Ribbon" }, { children: jsx_runtime_1.jsx(close_1.default, { stroke: (customStyles === null || customStyles === void 0 ? void 0 : customStyles.iconColours) || 'white' }, void 0) }), void 0)] }), void 0) }), void 0));
};
exports.default = DSRibbon;
